import { useEffect, FC } from 'react';

import { useRootStore } from '../../../../../root/RootStoreHooks';

export const Sony3ds: FC = () => {
  const store = useRootStore().moduleStores.threeDSecureEntry?.sony3ds;

  useEffect(() => {
    if (store?.isEnabled) {
      store.initAuth();
    }
  }, [store, store?.isEnabled]);

  return null;
};
